import type { LocalizedDict } from '../index'

type PreparePackStrings = {
  pageTitle: string
  subtitle: string
  step1: string
  step2: string
  step3: string
  step4: string
  packageCount: string
  createPackages: string
  packagesReady: (n: number) => string
  scanIn: string
  scanned: (s: number, e: number) => string
  seal: string
  sealed: string
  sealBlocked: string
  masterTracking: string
  depart: string
  departed: string
  timeline: string
  reset: string
  empty: string
}

export const SUPPLY_PREPARE_PACK_STRINGS: LocalizedDict<PreparePackStrings> = {
  en: {
    pageTitle: 'Prepare & Pack',
    subtitle:
      'Pack already-labeled customer packages into a master container and hand it off. The container cannot be sealed until every expected package is scanned.',
    step1: '1 · Create packages',
    step2: '2 · Scan into master container',
    step3: '3 · Seal',
    step4: '4 · Hand off (depart)',
    packageCount: 'Number of packages',
    createPackages: 'Create packages + container',
    packagesReady: (n) => `${n} package(s) ready to scan`,
    scanIn: 'Scan in',
    scanned: (s, e) => `Scanned ${s} / ${e}`,
    seal: 'Seal container',
    sealed: 'Sealed ✓',
    sealBlocked: 'Seal blocked — scan every expected package first.',
    masterTracking: 'Master tracking number',
    depart: 'Mark departed',
    departed: 'Departed ✓ — in transit',
    timeline: 'Custody timeline',
    reset: 'Start over',
    empty: 'No events yet.',
  },
  tr: {
    pageTitle: 'Hazırla & Paketle',
    subtitle:
      'Etiketi basılmış müşteri paketlerini bir ana koliye pakla ve teslim et. Beklenen her paket okutulmadan koli mühürlenemez.',
    step1: '1 · Paketleri oluştur',
    step2: '2 · Ana koliye okut',
    step3: '3 · Mühürle',
    step4: '4 · Teslim et (çıkış)',
    packageCount: 'Paket sayısı',
    createPackages: 'Paketleri + koliyi oluştur',
    packagesReady: (n) => `${n} paket okutmaya hazır`,
    scanIn: 'Okut',
    scanned: (s, e) => `Okutulan ${s} / ${e}`,
    seal: 'Koliyi mühürle',
    sealed: 'Mühürlendi ✓',
    sealBlocked: 'Mühürleme engellendi — önce beklenen tüm paketleri okut.',
    masterTracking: 'Ana takip numarası',
    depart: 'Çıkış yap',
    departed: 'Çıkış yapıldı ✓ — yolda',
    timeline: 'Zimmet geçmişi',
    reset: 'Baştan başla',
    empty: 'Henüz olay yok.',
  },
}
